import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Heart, BookOpen, Users, MapPin, Calendar, Award, Sparkles } from 'lucide-react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../Libs/firebase-config.mjs';

// Icon mapping
const ICON_MAP = {
  Heart,
  BookOpen,
  Users,
  MapPin,
  Calendar,
  Award,
  Sparkles
};

const WifeJourneySection = ({ darkMode }) => {
  const [wifeData, setWifeData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadWifeJourneyData();
  }, []);

  const loadWifeJourneyData = async () => {
    try {
      const docRef = doc(db, 'wifeJourneySection', 'content');
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        setWifeData(docSnap.data());
      } else {
        // Fallback to default data
        setWifeData({
          subtitle: 'A Woman of Faith',
          title: "Pastor Sally's Journey",
          description: "From Sunday school teacher to ordained pastor, a journey marked by unwavering faith, compassionate leadership, and transformative ministry.",
          featuredName: 'Pst. Sally Kyengo',
          featuredImage: 'https://res.cloudinary.com/dbacioerk/image/upload/v1763653241/unnamed_qol8mo.jpg',
          featuredQuote: "God doesn't call the qualified, He qualifies the called. My journey from a shy Sunday school teacher to a pastor has been nothing but God's grace. Every step, every challenge, every victory—all grace.",
          featuredRoles: [
            "Women's Ministry Leader",
            "Author & Conference Speaker",
            "Mentor to Young Female Pastors"
          ],
          journey: [
            { 
              year: "1992", 
              title: "The Call to Serve", 
              desc: "While serving as a Sunday school teacher in Kiambu, Sally felt God's call to full-time ministry. Her gift for children's ministry and pastoral care became evident.",
              location: "Kiambu, Kenya",
              icon: "Heart",
              img: "https://res.cloudinary.com/dbacioerk/image/upload/v1763653174/unnamed_opgua9.jpg",
              focus: "Teaching"
            },
            { 
              year: "1995", 
              title: "United in Purpose", 
              desc: "Marriage to Peter marked the beginning of a powerful ministry partnership. Together they planted their first church in Eastlands, blending their callings.",
              location: "Nairobi",
              icon: "Users",
              img: "https://res.cloudinary.com/dbacioerk/image/upload/v1763636346/pastors-rd1koyyyyhzzqqg7vahud891ljotap3jyzx4q8facq_ne0vb5.jpg",
              focus: "Partnership"
            },
            { 
              year: "2003", 
              title: "Women's Ministry Launch", 
              desc: "Founded the 'Daughters of Faith' women's ministry, reaching thousands of women across Kenya with messages of hope, healing, and empowerment.",
              location: "Nairobi",
              icon: "Award",
              img: "https://res.cloudinary.com/dbacioerk/image/upload/v1763653160/unnamed_ax28l7.jpg",
              focus: "Women"
            },
            { 
              year: "2012", 
              title: "Ordained Pastor", 
              desc: "Officially ordained as a pastor, recognizing her years of faithful service and anointed ministry. Her preaching ministry expanded across East Africa.",
              location: "Nairobi",
              icon: "BookOpen",
              img: "https://res.cloudinary.com/dbacioerk/image/upload/v1763653211/unnamed_jbarel.jpg",
              focus: "Leadership"
            },
            { 
              year: "2018", 
              title: "Author & Speaker", 
              desc: "Published her first book 'Faithful Journey: A Woman's Walk in Ministry' and became a sought-after speaker at women's conferences.",
              location: "East Africa",
              icon: "Sparkles",
              img: "https://res.cloudinary.com/dbacioerk/image/upload/v1763653228/unnamed_nzlxp5.jpg",
              focus: "Writing"
            },
            { 
              year: "2024", 
              title: "Continuing Legacy", 
              desc: "Leading women's ministry, mentoring young female pastors, and co-pastoring with her husband. Her influence continues to grow across Kenya.",
              location: "Kenya",
              icon: "Calendar",
              img: "https://res.cloudinary.com/dbacioerk/image/upload/v1763653257/unnamed_uot7vq.jpg",
              focus: "Mentoring"
            }
          ]
        });
      }
    } catch (err) {
      console.error('Error loading wife journey section:', err);
      // Set fallback data on error
      setWifeData({
        subtitle: 'A Woman of Faith',
        title: "Pastor Sally's Journey",
        description: "From Sunday school teacher to ordained pastor, a journey marked by unwavering faith, compassionate leadership, and transformative ministry.",
        featuredName: 'Pst. Sally Kyengo',
        featuredImage: 'https://res.cloudinary.com/dbacioerk/image/upload/v1763653241/unnamed_qol8mo.jpg',
        featuredQuote: "God doesn't call the qualified, He qualifies the called. My journey from a shy Sunday school teacher to a pastor has been nothing but God's grace. Every step, every challenge, every victory—all grace.",
        featuredRoles: [
          "Women's Ministry Leader",
          "Author & Conference Speaker",
          "Mentor to Young Female Pastors"
        ],
        journey: [
          { 
            year: "1992", 
            title: "The Call to Serve", 
            desc: "While serving as a Sunday school teacher in Kiambu, Sally felt God's call to full-time ministry. Her gift for children's ministry and pastoral care became evident.",
            location: "Kiambu, Kenya",
            icon: "Heart",
            img: "https://res.cloudinary.com/dbacioerk/image/upload/v1763653174/unnamed_opgua9.jpg",
            focus: "Teaching"
          },
          { 
            year: "1995", 
            title: "United in Purpose", 
            desc: "Marriage to Peter marked the beginning of a powerful ministry partnership. Together they planted their first church in Eastlands, blending their callings.",
            location: "Nairobi",
            icon: "Users",
            img: "https://res.cloudinary.com/dbacioerk/image/upload/v1763636346/pastors-rd1koyyyyhzzqqg7vahud891ljotap3jyzx4q8facq_ne0vb5.jpg",
            focus: "Partnership"
          },
          { 
            year: "2003", 
            title: "Women's Ministry Launch", 
            desc: "Founded the 'Daughters of Faith' women's ministry, reaching thousands of women across Kenya with messages of hope, healing, and empowerment.",
            location: "Nairobi",
            icon: "Award",
            img: "https://res.cloudinary.com/dbacioerk/image/upload/v1763653160/unnamed_ax28l7.jpg",
            focus: "Women"
          },
          { 
            year: "2012", 
            title: "Ordained Pastor", 
            desc: "Officially ordained as a pastor, recognizing her years of faithful service and anointed ministry. Her preaching ministry expanded across East Africa.",
            location: "Nairobi",
            icon: "BookOpen",
            img: "https://res.cloudinary.com/dbacioerk/image/upload/v1763653211/unnamed_jbarel.jpg",
            focus: "Leadership"
          },
          { 
            year: "2018", 
            title: "Author & Speaker", 
            desc: "Published her first book 'Faithful Journey: A Woman's Walk in Ministry' and became a sought-after speaker at women's conferences.",
            location: "East Africa",
            icon: "Sparkles",
            img: "https://res.cloudinary.com/dbacioerk/image/upload/v1763653228/unnamed_nzlxp5.jpg",
            focus: "Writing"
          },
          { 
            year: "2024", 
            title: "Continuing Legacy", 
            desc: "Leading women's ministry, mentoring young female pastors, and co-pastoring with her husband. Her influence continues to grow across Kenya.",
            location: "Kenya",
            icon: "Calendar",
            img: "https://res.cloudinary.com/dbacioerk/image/upload/v1763653257/unnamed_uot7vq.jpg",
            focus: "Mentoring"
          }
        ]
      });
    } finally {
      setLoading(false);
    }
  };

  // Show loading state
  if (loading) {
    return (
      <section 
        className={`py-32 px-8 ${darkMode ? 'bg-slate-900' : 'bg-gradient-to-br from-slate-50 to-rose-50/20'} transition-colors duration-300`}
        style={{ minHeight: '400px', visibility: 'visible', opacity: 1 }}
      >
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <div className={`text-lg ${darkMode ? 'text-slate-300' : 'text-slate-700'}`}>
              Loading Wife's Journey Section...
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!wifeData) {
    return null;
  }

  const data = wifeData;

  return (
    <section className={`py-32 px-8 ${darkMode ? 'bg-slate-900' : 'bg-gradient-to-br from-slate-50 to-rose-50/20'} transition-colors duration-300 overflow-hidden`}>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <motion.div
            initial={{ scale: 0 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true }}
            transition={{ type: "spring", stiffness: 200, delay: 0.2 }}
            className="inline-block mb-6"
          >
            <div className={`w-20 h-20 rounded-full ${darkMode ? 'bg-slate-800' : 'bg-white'} shadow-lg flex items-center justify-center border ${darkMode ? 'border-slate-700' : 'border-slate-200'}`}>
              <Heart className={`w-10 h-10 ${darkMode ? 'text-rose-400' : 'text-rose-600'}`} />
            </div>
          </motion.div>
          <div className={`text-sm uppercase tracking-widest ${darkMode ? 'text-slate-400' : 'text-slate-500'} font-medium mb-4 font-sans`}>
            {data.subtitle}
          </div>
          <h2 className={`text-5xl md:text-6xl font-bold ${darkMode ? 'text-white' : 'text-slate-900'} mb-6 font-sans`}>
            {data.title}
          </h2>
          <p className={`text-xl ${darkMode ? 'text-slate-300' : 'text-slate-600'} max-w-3xl mx-auto leading-relaxed font-sans`}>
            {data.description}
          </p>
        </motion.div>

        {/* Featured Sally Section */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20"
        >
          <div className={`${darkMode ? 'bg-slate-800' : 'bg-white'} rounded-3xl shadow-xl border ${darkMode ? 'border-slate-700' : 'border-slate-200'} overflow-hidden`}>
            <div className="grid md:grid-cols-2">
              <div className="relative h-96 md:h-auto min-h-[500px]">
                <img 
                  src={data.featuredImage} 
                  alt={data.featuredName}
                  className="w-full h-full object-contain"
                />
                <div className={`absolute inset-0 ${darkMode ? 'bg-slate-900/30' : 'bg-white/10'}`} />
              </div>
              <div className="p-8 md:p-12 flex flex-col justify-center">
                <h3 className={`text-4xl font-bold ${darkMode ? 'text-white' : 'text-slate-900'} mb-6 font-sans`}>
                  {data.featuredName}
                </h3>
                <blockquote className={`text-xl ${darkMode ? 'text-slate-300' : 'text-slate-600'} leading-relaxed italic mb-6 border-l-4 ${darkMode ? 'border-rose-400' : 'border-rose-500'} pl-6 font-sans`}>
                  "{data.featuredQuote}"
                </blockquote>
                <div className={`space-y-3 ${darkMode ? 'text-slate-400' : 'text-slate-600'} font-sans`}>
                  {data.featuredRoles && data.featuredRoles.length > 0 ? (
                    data.featuredRoles.map((role, index) => (
                      <div key={index} className="flex items-center gap-3">
                        <Heart className="w-5 h-5" />
                        <span>{role}</span>
                      </div>
                    ))
                  ) : (
                    <div className="flex items-center gap-3">
                      <Heart className="w-5 h-5" />
                      <span>Ministry Leader</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Journey Timeline */}
        <div className="relative">
          {/* Vertical Timeline Line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full hidden lg:block">
            <motion.div
              initial={{ scaleY: 0 }}
              whileInView={{ scaleY: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.5, ease: "easeOut" }}
              className={`w-full h-full ${darkMode ? 'bg-gradient-to-b from-slate-600 via-slate-500 to-slate-400' : 'bg-gradient-to-b from-slate-300 via-slate-200 to-slate-300'} rounded-full`}
            />
          </div>

          {/* Connection Dots */}
          <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-full hidden lg:block">
            {data.journey && data.journey.map((_, index) => (
              <motion.div
                key={index}
                initial={{ scale: 0, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2, type: "spring", stiffness: 200 }}
                className={`absolute left-1/2 transform -translate-x-1/2 w-4 h-4 rounded-full ${darkMode ? 'bg-rose-400' : 'bg-rose-500'} shadow-sm border ${darkMode ? 'border-rose-300' : 'border-rose-200'}`}
                style={{ top: `${(index / (data.journey.length - 1)) * 100}%` }}
              />
            ))}
          </div>

          {/* Milestones */}
          <div className="space-y-24 lg:space-y-32">
            {data.journey && data.journey.length > 0 ? (
              data.journey.map((milestone, index) => (
                <SallyJourneyMilestone 
                  key={index} 
                  milestone={milestone} 
                  index={index} 
                  darkMode={darkMode} 
                />
              ))
            ) : (
              <div className={`text-center text-lg ${darkMode ? 'text-slate-300' : 'text-slate-700'}`}>
                No journey milestones available
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

const SallyJourneyMilestone = ({ milestone, index, darkMode }) => {
  const IconComponent = ICON_MAP[milestone.icon] || Heart;
  const isEven = index % 2 === 0;

  const cardVariants = {
    hidden: { 
      opacity: 0, 
      x: isEven ? -50 : 50,
      y: 20
    },
    visible: { 
      opacity: 1, 
      x: 0,
      y: 0,
      transition: {
        duration: 0.8,
        delay: index * 0.15,
        ease: "easeOut"
      }
    }
  };

  const imageVariants = {
    hidden: { 
      opacity: 0, 
      scale: 0.8,
      rotate: isEven ? -5 : 5
    },
    visible: { 
      opacity: 1, 
      scale: 1,
      rotate: 0,
      transition: {
        duration: 0.8,
        delay: index * 0.15 + 0.2,
        ease: "easeOut"
      }
    }
  };

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      className={`relative flex flex-col lg:flex-row items-center gap-12 ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}
    >
      {/* Content Card */}
      <motion.div 
        variants={cardVariants}
        className="flex-1 w-full lg:max-w-2xl"
      >
        <motion.div
          whileHover={{ y: -5 }}
          className={`${darkMode ? 'bg-slate-800' : 'bg-white'} p-10 rounded-2xl shadow-lg border ${darkMode ? 'border-slate-700' : 'border-slate-200'} relative overflow-hidden group transition-all duration-300 h-full min-h-[400px] flex flex-col justify-center`}
        >
          {/* Subtle background pattern */}
          <div className="absolute inset-0 opacity-[0.02] group-hover:opacity-[0.03] transition-opacity duration-500 bg-gradient-to-br from-rose-400 to-rose-600" />
          
          {/* Year Badge */}
          <motion.div
            initial={{ scale: 0 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.15 + 0.1, type: "spring", stiffness: 200 }}
            className={`inline-flex items-center gap-3 px-4 py-2 rounded-full ${darkMode ? 'bg-slate-700' : 'bg-rose-50'} mb-6 border ${darkMode ? 'border-slate-600' : 'border-rose-200'}`}
          >
            <div className={`w-2 h-2 rounded-full ${darkMode ? 'bg-rose-400' : 'bg-rose-500'}`} />
            <span className={`font-semibold ${darkMode ? 'text-slate-300' : 'text-rose-700'} font-sans`}>
              {milestone.year}
            </span>
          </motion.div>

          {/* Icon and Title */}
          <div className="flex items-center gap-4 mb-6">
            <div className={`p-3 rounded-xl ${darkMode ? 'bg-slate-700' : 'bg-rose-50'} border ${darkMode ? 'border-slate-600' : 'border-rose-200'}`}>
              <IconComponent className={`w-7 h-7 ${darkMode ? 'text-rose-400' : 'text-rose-600'}`} />
            </div>
            <div>
              <h3 className={`text-3xl md:text-4xl font-bold ${darkMode ? 'text-white' : 'text-slate-900'} mb-3 font-sans`}>
                {milestone.title}
              </h3>
              <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full ${darkMode ? 'bg-slate-700' : 'bg-slate-100'} border ${darkMode ? 'border-slate-600' : 'border-slate-200'}`}>
                <span className={`text-sm font-medium ${darkMode ? 'text-slate-300' : 'text-slate-600'} font-sans`}>
                  {milestone.focus}
                </span>
              </div>
            </div>
          </div>

          {/* Description */}
          <p className={`text-xl ${darkMode ? 'text-slate-300' : 'text-slate-600'} mb-8 leading-relaxed font-sans flex-grow`}>
            {milestone.desc}
          </p>

          {/* Location */}
          <div className="flex items-center gap-3">
            <MapPin className={`w-5 h-5 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`} />
            <span className={`text-base ${darkMode ? 'text-slate-400' : 'text-slate-500'} font-medium font-sans`}>
              {milestone.location}
            </span>
          </div>
        </motion.div>
      </motion.div>

      {/* Image Card */}
      <motion.div 
        variants={imageVariants}
        className="flex-1 w-full lg:max-w-xl"
      >
        <motion.div
          whileHover={{ scale: 1.02 }}
          className="relative group h-full min-h-[500px]"
        >
          {/* Main Image with refined styling */}
          <div className="relative z-10 overflow-hidden rounded-2xl h-full">
            <img 
              src={milestone.img} 
              alt={milestone.title}
              className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
            />
            {/* Subtle overlay */}
            <div className={`absolute inset-0 rounded-2xl ${darkMode ? 'bg-slate-900/20' : 'bg-rose-50/10'} transition-opacity duration-300 group-hover:opacity-0`} />
          </div>

          {/* Subtle border effect */}
          <div className={`absolute -inset-2 rounded-2xl ${darkMode ? 'bg-rose-500/10' : 'bg-rose-200/50'} blur-sm transition-all duration-300 group-hover:blur-md group-hover:opacity-70`} />
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default WifeJourneySection;